<template lang="html">
    <report-section
        :id="id"
        title="Topography"
    >
        <p>
            The elevation of a watershed is a primary control on climate, vegetation, and timing of hydrologic
            processes such as onset of spring melt. The amount, and state of precipitation changes with elevation.
            Temperatures vary by elevation, with gradients typically differing in direction between winter and summer
            (with valley bottoms typically colder in winter than higher elevations, and higher alpine areas colder in
            summer than the valley bottoms). The hypsometric curve shown in the chart below, shows the cumulative
            distribution of elevation by area in the watershed. Percent values on the x-axis can be used to determine
            the percentage of the watershed above a given elevation value.
        </p>

        <topography-chart
            class="topography-chart"
            :graph-data="formattedData"
            :provided-options="chartOptions"
        />
        <chart-legend
            :items="legendItems"
            class="legend"
        />
    </report-section>
</template>

<script>
import ChartLegend from '@foundryspatial/chart-legend';
import sectionMixin from '@foundryspatial/report-section/mixin';

import scssVars from '@/assets/scss/_variables.scss';
import TopographyChart from '@/components/charts/LineWithAreaChart';

export default {
    name: 'Topography',

    components: {
        ChartLegend,
        TopographyChart,
    },

    mixins: [
        sectionMixin,
    ],

    computed: {
        formattedData() {
            return this.reportData.overview.elevs.map((elev, index) => (
                {
                    x: index + 1,
                    y: elev,
                    min: this.reportData.overview.elevs_flat[index],
                    max: this.reportData.overview.elevs_steep[index],
                }
            ));
        },

        chartOptions() {
            return {
                xAxisLabel: 'Cumulative',
                yAxisLabel: 'Elevation',
                xUnitOfMeasurement: '%',
                yUnitOfMeasurement: 'm',
                roundToDecimalPlaces: 1,
                tooltipSignal: this.tooltipSignal,
                hideTooltip: false,
            };
        },

        tooltipSignal() {
            return 'datum.x + "% of the watershed is above " + datum.y + "m elevation"';
        },

        legendItems() {
            return [
                {
                    legendLabel: 'Elevation range in watersheds > 300 km²',
                    color: scssVars.colorTopographyChartArea,
                    labelOrder: 1,
                    legendType: 'box',
                },
            ];
        },
    },
};
</script>

<style lang="scss">
#topography.report-section {
    .topography-chart {
        height: 20em;
        width: 100%;
        margin-bottom: 1rem;
    }
}

.static-report #topography.report-section {
    .topography-chart {
        margin-top: 1.25rem;
        height: 470px;
    }
}
</style>
